// extracted by mini-css-extract-plugin
export default {"homeWrapper":"mintBox_homeWrapper__-oE3j"};